import React, { Component } from "react";
import { connect } from "react-redux";
import { throttle } from "lodash";
import { getTransform } from "./hotspot";
import { injectIntl, FormattedMessage } from "react-intl";

import { TranslationsProvider } from "@learningblocks/simulations/shared-components";

import { fetchTranslations } from "./locales/config";

import { setGelPrediction, setGelPredictionBandToggle } from "./store/actions";

import "./styles.scss";

import gelPrediction from "./img/gel-prediction.svg";
import upImg from "./img/btn-up.svg";
import downImg from "./img/btn-down.svg";

class GelPredictions512 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dragged: null,
      y1a: this.props.bands.lane1a,
      y1b: this.props.bands.lane1b,
      y2a: this.props.bands.lane2a,
      y2b: this.props.bands.lane2b,
      y3a: this.props.bands.lane3a,
      y3b: this.props.bands.lane3b,
      y4a: this.props.bands.lane4a,
      y4b: this.props.bands.lane4b,
      y1alast: 0,
      y1blast: 0,
      y2alast: 0,
      y2blast: 0,
      y3alast: 0,
      y3blast: 0,
      y4alast: 0,
      y4blast: 0,
    };
  }

  onDragStart = (e) => {
    let dragImage = document.getElementById("dragImage");

    if (dragImage == null) {
      dragImage = document.createElement("img");
      dragImage.id = "dragImage";
      dragImage.src =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==";
      document.body.appendChild(dragImage);
    }
    dragImage.style.position = "absolute";
    dragImage.style.top = 0;
    dragImage.style.left = 0;

    const testVar = window.DataTransfer || window.Clipboard; // Clipboard is for Chrome
    if ("setDragImage" in testVar.prototype) {
      e.dataTransfer.setDragImage(dragImage, 0, 0);
    }
    if ("setData" in testVar.prototype) {
      e.dataTransfer.setData("text/plain", "");
    }

    const index = e.target.id;

    this.setState({
      ["y" + index + "last"]: e.clientY,
      dragged: e.target,
    });
  };

  drag = throttle((target, clientX, clientY) => {
    if (target) {
      const transform = getTransform(target);
      const lane = target.parentNode.id.split("-")[1];
      const index = target.id;

      if (lane) {
        const iYPos = parseFloat(transform.translateY);
        const newY = clientY + iYPos - this.state["y" + index + "last"];

        if (newY >= 0 && newY <= 630) {
          this.setState({
            ["y" + index]: newY,
            ["y" + index + "last"]: clientY,
          });
        }
      }
    }
  }, 20);

  onDragOver = (e) => {
    e.preventDefault();
    this.drag(this.state.dragged, e.clientX, e.clientY);
  };

  onDragEnd = (e) => {
    e.preventDefault();
    this.props.setGelPrediction({
      id: 1,
      bands: {
        lane1a: this.state.y1a,
        lane1b: this.state.y1b,
        lane2a: this.state.y2a,
        lane2b: this.state.y2b,
        lane3a: this.state.y3a,
        lane3b: this.state.y3b,
        lane4a: this.state.y4a,
        lane4b: this.state.y4b,
      },
    });

    this.setState({
      dragged: null,
    });
  };

  moveDown = (band) => {
    if (this.state["y" + band] + 10 <= 630) {
      this.setState({
        ["y" + band]: this.state["y" + band] + 10,
        ["y" + band + "last"]: this.state["y" + band] + 10,
      });
      this.submitPrediction();
    }
  };

  moveUp = (band) => {
    if (this.state["y" + band] - 10 >= 0) {
      this.setState({
        ["y" + band]: this.state["y" + band] - 10,
        ["y" + band + "last"]: this.state["y" + band] - 10,
      });
      this.submitPrediction();
    }
  };

  toggle2ndBand = (lane) => {
    this.props.setGelPredictionBandToggle({
      id: 1,
      toggles: {
        lane1:
          lane === 1 ? !this.props.toggles.lane1 : this.props.toggles.lane1,
        lane2:
          lane === 2 ? !this.props.toggles.lane2 : this.props.toggles.lane2,
        lane3:
          lane === 3 ? !this.props.toggles.lane3 : this.props.toggles.lane3,
        lane4:
          lane === 4 ? !this.props.toggles.lane4 : this.props.toggles.lane4,
      },
    });
  };

  submitPrediction = () => {
    this.props.setGelPrediction({
      id: 1,
      bands: {
        lane1a: this.state.y1a,
        lane1b: this.state.y1b,
        lane2a: this.state.y2a,
        lane2b: this.state.y2b,
        lane3a: this.state.y3a,
        lane3b: this.state.y3b,
        lane4a: this.state.y4a,
        lane4b: this.state.y4b,
      },
    });
  };

  convertOffset = (x) => {
    x = Math.round(x);
    return Math.round(Math.pow(2.71828, -((10 * x - 7504) / 1359)));
  };

  render() {
    const { intl } = this.props;
    return (
      <div className="Predictions">
        <div
          className="predictions-question-container"
          style={{ marginTop: 0 }}
        >
          <h3 style={{ margin: 0 }}>
            <FormattedMessage
              id="Predict Bands"
              defaultMessage="Predict Bands"
              description=""
            />
          </h3>
          <p>
            <FormattedMessage
              id="In the gel below, you will predict the band pattern that can be expected if:"
              defaultMessage="In the gel below, you will predict the band pattern that can be expected if:"
              description=""
            />
          </p>
          <p>
            <FormattedMessage
              id="• CRISPR-Cas9 disrupted CCR5 successfully, and"
              defaultMessage="• CRISPR-Cas9 disrupted CCR5 successfully, and"
              description=""
            />
          </p>
          <p>
            <FormattedMessage
              id="• Western blotting of CRISPR-edited macrophages and control cells has worked."
              defaultMessage="• Western blotting of CRISPR-edited macrophages and control cells has worked."
              description=""
            />
          </p>
          <p
            aria-label={intl.formatMessage({
              id: "Indicate in which lane you expect CCR5 bands (shown in red), alpha tubulin bands (shown in green), or both. (Note that CCR5 has a molecular weight of 40 kilodaltons and alpha tubulin of 55 kilodaltons.)",
              defaultMessage:
                "Indicate in which lane you expect CCR5 bands (shown in red), alpha tubulin bands (shown in green), or both. (Note that CCR5 has a molecular weight of 40 kilodaltons and alpha tubulin of 55 kilodaltons.)",
              description: "",
            })}
          >
            <FormattedMessage
              id="Indicate in which lane you expect CCR5 bands (shown in red), alpha tubulin bands (shown in green), or both. (Note that CCR5 has a molecular weight of 40 kDa and alpha tubulin of 55 kDa.)"
              defaultMessage="Indicate in which lane you expect CCR5 bands (shown in red), alpha tubulin bands (shown in green), or both. (Note that CCR5 has a molecular weight of 40 kDa and alpha tubulin of 55 kDa.)"
              description=""
            />
          </p>
          <p>
            <FormattedMessage
              id="Drag or use the buttons to move a particular band to the desired molecular weight position in the gel. If you need to create an additional band in a certain gel lane, click on the sample name above the lane (for example, if you need a second band in the thirdlane click on “pancreas cells”)."
              defaultMessage="Drag or use the buttons to move a particular band to the desired molecular weight position in the gel. If you need to create an additional band in a certain gel lane, click on the sample name above the lane (for example, if you need a second band in the thirdlane click on “pancreas cells”)."
              description=""
            />
          </p>

          <div className="gel-container">
            <div className="lane-legend">
              <div
                className="lane-legend__type"
                aria-label={intl.formatMessage({
                  id: "Protein Ladder (kDa).",
                  defaultMessage: "Protein Ladder (kDa).",
                  description: "",
                })}
              >
                <label
                  htmlFor="protein-ladder"
                  className="lane-legend__type--label"
                >
                  1
                </label>
                <div className="lane-legend__type--wt">
                  <p
                    id="protein-ladder"
                    aria-label="Protein Ladder (kilodaltons)"
                  >
                    <FormattedMessage
                      id="Protein Ladder (kDa)"
                      defaultMessage="Protein Ladder (kDa)"
                      description=""
                    />
                  </p>
                </div>
              </div>
              <div
                role="button"
                className="lane-legend__type"
                aria-label={intl.formatMessage(
                  {
                    id: "Wild type macrophage cells. {toggle}",
                    defaultMessage: "Wild type macrophage cells. {toggle}",
                    description: "",
                  },
                  {
                    toggle: !this.props.toggles.lane1
                      ? intl.formatMessage({
                          id: "Select to generate a CCR5 band in this gel lane.",
                          defaultMessage:
                            "Select to generate a CCR5 band in this gel lane.",
                          description: "",
                        })
                      : intl.formatMessage({
                          id: "Select to remove the CCR5 band in this gel lane.",
                          defaultMessage:
                            "Select to remove the CCR5 band in this gel lane.",
                          description: "",
                        }),
                  }
                )}
                onClick={() => this.toggle2ndBand(1)}
                onKeyDown={(e) => {
                  if (e.which === 13 || e.which === 32) this.toggle2ndBand(1);
                }}
                tabIndex={0} // Ensure the element is tabbable
              >
                <label
                  htmlFor="Wild-Type-Macrophage"
                  className="lane-legend__type--label"
                >
                  2
                </label>
                <div
                  id="Wild-Type-Macrophage"
                  className="lane-legend__type--wt"
                >
                  <p>
                    <FormattedMessage
                      id="Wild Type Macrophage Cells"
                      defaultMessage="Wild Type Macrophage Cells"
                      description=""
                    />
                  </p>
                </div>
              </div>
              <div
                role="button"
                className="lane-legend__type"
                aria-label={intl.formatMessage(
                  {
                    id: "Pancreas cells. {toggle}",
                    defaultMessage: "Pancreas cells. {toggle}",
                    description: "",
                  },
                  {
                    toggle: !this.props.toggles.lane2
                      ? intl.formatMessage({
                          id: "Select to generate a CCR5 band in this gel lane.",
                          defaultMessage:
                            "Select to generate a CCR5 band in this gel lane.",
                          description: "",
                        })
                      : intl.formatMessage({
                          id: "Select to remove the CCR5 band in this gel lane.",
                          defaultMessage:
                            "Select to remove the CCR5 band in this gel lane.",
                          description: "",
                        }),
                  }
                )}
                onClick={() => this.toggle2ndBand(2)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    this.toggle2ndBand(2);
                  }
                }}
                tabIndex={0} // Ensure the element is tabbable
              >
                <label
                  htmlFor="Pancreas-Cells"
                  className="lane-legend__type--label"
                >
                  3
                </label>
                <div id="Pancreas-Cells" className="lane-legend__type--pc">
                  <p>
                    <FormattedMessage
                      id="Pancreas Cells"
                      defaultMessage="Pancreas Cells"
                      description=""
                    />
                  </p>
                </div>
              </div>
              <div
                role="button"
                className="lane-legend__type"
                aria-label={intl.formatMessage(
                  {
                    id: "Gene-edited macrophage cells (edit 4). {toggle}",
                    defaultMessage:
                      "Gene-edited macrophage cells (edit 4). {toggle}",
                    description: "",
                  },
                  {
                    toggle: !this.props.toggles.lane3
                      ? intl.formatMessage({
                          id: "Select to generate a CCR5 band in this gel lane.",
                          defaultMessage:
                            "Select to generate a CCR5 band in this gel lane.",
                          description: "",
                        })
                      : intl.formatMessage({
                          id: "Select to remove the CCR5 band in this gel lane.",
                          defaultMessage:
                            "Select to remove the CCR5 band in this gel lane.",
                          description: "",
                        }),
                  }
                )}
                onClick={() => this.toggle2ndBand(3)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    this.toggle2ndBand(3);
                  }
                }}
                tabIndex={0} // Ensure the element is tabbable
              >
                <label
                  htmlFor="Gene-edited-Macrophage"
                  className="lane-legend__type--label"
                >
                  4
                </label>
                <div
                  id="Gene-edited-Macrophage"
                  className="lane-legend__type--e4"
                >
                  <p>
                    <FormattedMessage
                      id="Gene-edited Macrophage Cells (Edit 4)"
                      defaultMessage="Gene-edited Macrophage Cells (Edit 4)"
                      description=""
                    />
                  </p>
                </div>
              </div>
              <div
                role="button"
                className="lane-legend__type"
                aria-label={intl.formatMessage(
                  {
                    id: "Gene-edited macrophage cells (edit 7). {toggle}",
                    defaultMessage:
                      "Gene-edited macrophage cells (edit 7). {toggle}",
                    description: "",
                  },
                  {
                    toggle: !this.props.toggles.lane4
                      ? intl.formatMessage({
                          id: "Select to generate a CCR5 band in this gel lane.",
                          defaultMessage:
                            "Select to generate a CCR5 band in this gel lane.",
                          description: "",
                        })
                      : intl.formatMessage({
                          id: "Select to remove the CCR5 band in this gel lane.",
                          defaultMessage:
                            "Select to remove the CCR5 band in this gel lane.",
                          description: "",
                        }),
                  }
                )}
                onClick={() => this.toggle2ndBand(4)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    this.toggle2ndBand(4);
                  }
                }}
                tabIndex={0} // Ensure the element is tabbable
              >
                <label
                  htmlFor="Macrophage-legend"
                  className="lane-legend__type--label"
                >
                  5
                </label>
                <div id="Macrophage-legend" className="lane-legend__type--e7">
                  <p>
                    <FormattedMessage
                      id="Gene-edited Macrophage Cells (Edit 7)"
                      defaultMessage="Gene-edited Macrophage Cells (Edit 7)"
                      description=""
                    />
                  </p>
                </div>
              </div>
            </div>

            <div className="Gel-prediction">
              <div className="lanes">
                <div
                  id="lane-1"
                  className="lane lane-1"
                  onDragStart={this.onDragStart}
                  onDragOver={this.onDragOver}
                  onDragEnd={this.onDragEnd}
                >
                  <div
                    id="1a"
                    className="draggable particle"
                    draggable
                    style={{
                      transform:
                        "translate3d(0px, " +
                        this.state.y1a +
                        "px, 0px) rotateZ(0deg)",
                      zIndex: 10,
                      position: "absolute",
                      pointerEvents: "none",
                    }}
                  >
                    <button
                      className="btn-trigger"
                      onClick={() => this.moveUp("1a")}
                    >
                      <img
                        width="25"
                        src={upImg}
                        alt={intl.formatMessage(
                          {
                            id: "Wild Type Macrophage Cells. Move alpha tubulin band up. Currently set to {offset} bp.",
                            defaultMessage:
                              "Wild Type Macrophage Cells. Move alpha tubulin band up. Currently set to {offset} bp.",
                            description: "",
                          },
                          {
                            offset: this.convertOffset(this.state.y1a),
                          }
                        )}
                      />
                    </button>
                    <button
                      className="btn-trigger"
                      onClick={() => this.moveDown("1a")}
                    >
                      <img
                        width="25"
                        src={downImg}
                        alt={intl.formatMessage(
                          {
                            id: "Wild Type Macrophage Cells. Move alpha tubulin band down. Currently set to {offset} bp.",
                            defaultMessage:
                              "Wild Type Macrophage Cells. Move alpha tubulin band down. Currently set to {offset} bp.",
                            description: "",
                          },
                          {
                            offset: this.convertOffset(this.state.y1a),
                          }
                        )}
                      />
                    </button>
                  </div>
                  <div
                    id="1b"
                    className={
                      "draggable particle" +
                      (this.props.toggles.lane1 ? "" : " hidden")
                    }
                    draggable
                    style={{
                      transform:
                        "translate3d(0px, " +
                        this.state.y1b +
                        "px, 0px) rotateZ(0deg)",
                      zIndex: 10,
                      position: "absolute",
                      pointerEvents: "none",
                    }}
                  >
                    <button
                      className="btn-trigger"
                      onClick={() => this.moveUp("1b")}
                    >
                      <img
                        width="25"
                        src={upImg}
                        alt={intl.formatMessage(
                          {
                            id: "Wild Type Macrophage Cells. Move CCR5 band up. Currently set to  {offset} bp.",
                            defaultMessage:
                              "Wild Type Macrophage Cells. Move CCR5 band up. Currently set to  {offset} bp.",
                            description: "",
                          },
                          {
                            offset: this.convertOffset(this.state.y1b),
                          }
                        )}
                      />
                    </button>
                    <button
                      className="btn-trigger"
                      onClick={() => this.moveDown("1b")}
                    >
                      <img
                        width="25"
                        src={downImg}
                        alt={intl.formatMessage(
                          {
                            id: "Wild Type Macrophage Cells. Move CCR5 band down. Currently set to  {offset} bp.",
                            defaultMessage:
                              "Wild Type Macrophage Cells. Move CCR5 band down. Currently set to  {offset} bp.",
                            description: "",
                          },
                          {
                            offset: this.convertOffset(this.state.y1b),
                          }
                        )}
                      />
                    </button>
                  </div>
                </div>

                <div
                  id="lane-2"
                  className="lane lane-2"
                  onDragStart={this.onDragStart}
                  onDragOver={this.onDragOver}
                  onDragEnd={this.onDragEnd}
                >
                  <div
                    id="2a"
                    className="draggable particle"
                    draggable
                    style={{
                      transform:
                        "translate3d(0px, " +
                        this.state.y2a +
                        "px, 0px) rotateZ(0deg)",
                      zIndex: 10,
                      position: "absolute",
                      pointerEvents: "none",
                    }}
                  >
                    <button
                      className="btn-trigger"
                      onClick={() => this.moveUp("2a")}
                    >
                      <img
                        width="25"
                        src={upImg}
                        alt={intl.formatMessage(
                          {
                            id: "Pancreas Cells. Move alpha tubulin band up. Currently set to {offset} bp.",
                            defaultMessage:
                              "Pancreas Cells. Move alpha tubulin band up. Currently set to {offset} bp.",
                            description: "",
                          },
                          {
                            offset: this.convertOffset(this.state.y2a),
                          }
                        )}
                      />
                    </button>
                    <button
                      className="btn-trigger"
                      onClick={() => this.moveDown("2a")}
                    >
                      <img
                        width="25"
                        src={downImg}
                        alt={intl.formatMessage(
                          {
                            id: "Pancreas Cells. Move alpha tubulin band down. Currently set to {offset} bp.",
                            defaultMessage:
                              "Pancreas Cells. Move alpha tubulin band down. Currently set to {offset} bp.",
                            description: "",
                          },
                          {
                            offset: this.convertOffset(this.state.y2a),
                          }
                        )}
                      />
                    </button>
                  </div>
                  <div
                    id="2b"
                    className={
                      "draggable particle" +
                      (this.props.toggles.lane2 ? "" : " hidden")
                    }
                    draggable
                    style={{
                      transform:
                        "translate3d(0px, " +
                        this.state.y2b +
                        "px, 0px) rotateZ(0deg)",
                      zIndex: 10,
                      position: "absolute",
                      pointerEvents: "none",
                    }}
                  >
                    <button
                      className="btn-trigger"
                      onClick={() => this.moveUp("2b")}
                    >
                      <img
                        width="25"
                        src={upImg}
                        alt={intl.formatMessage(
                          {
                            id: "Pancreas Cells. Move CCR5 band up. Currently set to {offset} bp.",
                            defaultMessage:
                              "Pancreas Cells. Move CCR5 band up. Currently set to {offset} bp.",
                            description: "",
                          },
                          {
                            offset: this.convertOffset(this.state.y2b),
                          }
                        )}
                      />
                    </button>
                    <button
                      className="btn-trigger"
                      onClick={() => this.moveDown("2b")}
                    >
                      <img
                        width="25"
                        src={downImg}
                        alt={intl.formatMessage(
                          {
                            id: "Pancreas Cells. Move CCR5 band down. Currently set to {offset} bp.",
                            defaultMessage:
                              "Pancreas Cells. Move CCR5 band down. Currently set to {offset} bp.",
                            description: "",
                          },
                          {
                            offset: this.convertOffset(this.state.y2b),
                          }
                        )}
                      />
                    </button>
                  </div>
                </div>

                <div
                  id="lane-3"
                  className="lane lane-3"
                  onDragStart={this.onDragStart}
                  onDragOver={this.onDragOver}
                  onDragEnd={this.onDragEnd}
                >
                  <div
                    id="3a"
                    className="draggable particle"
                    draggable
                    style={{
                      transform:
                        "translate3d(0px, " +
                        this.state.y3a +
                        "px, 0px) rotateZ(0deg)",
                      zIndex: 10,
                      position: "absolute",
                      pointerEvents: "none",
                    }}
                  >
                    <button
                      className="btn-trigger"
                      onClick={() => this.moveUp("3a")}
                    >
                      <img
                        width="25"
                        src={upImg}
                        alt={intl.formatMessage(
                          {
                            id: "Gene-edited macrophage cells (edit 4). Move alpha tubulin band up. Currently set to {offset} bp.",
                            defaultMessage:
                              "Gene-edited macrophage cells (edit 4). Move alpha tubulin band up. Currently set to {offset} bp.",
                            description: "",
                          },
                          {
                            offset: this.convertOffset(this.state.y3a),
                          }
                        )}
                      />
                    </button>
                    <button
                      className="btn-trigger"
                      onClick={() => this.moveDown("3a")}
                    >
                      <img
                        width="25"
                        src={downImg}
                        alt={intl.formatMessage(
                          {
                            id: "Gene-edited macrophage cells (edit 4). Move alpha tubulin band down. Currently set to {offset} bp.",
                            defaultMessage:
                              "Gene-edited macrophage cells (edit 4). Move alpha tubulin band down. Currently set to {offset} bp.",
                            description: "",
                          },
                          {
                            offset: this.convertOffset(this.state.y3a),
                          }
                        )}
                      />
                    </button>
                  </div>
                  <div
                    id="3b"
                    className={
                      "draggable particle" +
                      (this.props.toggles.lane3 ? "" : " hidden")
                    }
                    draggable
                    style={{
                      transform:
                        "translate3d(0px, " +
                        this.state.y3b +
                        "px, 0px) rotateZ(0deg)",
                      zIndex: 10,
                      position: "absolute",
                      pointerEvents: "none",
                    }}
                  >
                    <button
                      className="btn-trigger"
                      onClick={() => this.moveUp("3b")}
                    >
                      <img
                        width="25"
                        src={upImg}
                        alt={intl.formatMessage(
                          {
                            id: "Gene-edited macrophage cells (edit 4). Move CCR5 band up. Currently set to {offset} bp.",
                            defaultMessage:
                              "Gene-edited macrophage cells (edit 4). Move CCR5 band up. Currently set to {offset} bp.",
                            description: "",
                          },
                          {
                            offset: this.convertOffset(this.state.y3b),
                          }
                        )}
                      />
                    </button>
                    <button
                      className="btn-trigger"
                      onClick={() => this.moveDown("3b")}
                    >
                      <img
                        width="25"
                        src={downImg}
                        alt={intl.formatMessage(
                          {
                            id: "Gene-edited macrophage cells (edit 4). Move CCR5 band down. Currently set to {offset} bp.",
                            defaultMessage:
                              "Gene-edited macrophage cells (edit 4). Move CCR5 band down. Currently set to {offset} bp.",
                            description: "",
                          },
                          {
                            offset: this.convertOffset(this.state.y3b),
                          }
                        )}
                      />
                    </button>
                  </div>
                </div>

                <div
                  id="lane-4"
                  className="lane lane-4"
                  onDragStart={this.onDragStart}
                  onDragOver={this.onDragOver}
                  onDragEnd={this.onDragEnd}
                >
                  <div
                    id="4a"
                    className="draggable particle"
                    draggable
                    style={{
                      transform:
                        "translate3d(0px, " +
                        this.state.y4a +
                        "px, 0px) rotateZ(0deg)",
                      zIndex: 10,
                      position: "absolute",
                      pointerEvents: "none",
                    }}
                  >
                    <button
                      className="btn-trigger"
                      onClick={() => this.moveUp("4a")}
                    >
                      <img
                        width="25"
                        src={upImg}
                        alt={intl.formatMessage(
                          {
                            id: "Gene-edited macrophage cells (edit 7). Move alpha tubulin band up. Currently set to {offset} bp.",
                            defaultMessage:
                              "Gene-edited macrophage cells (edit 7). Move alpha tubulin band up. Currently set to {offset} bp.",
                            description: "",
                          },
                          {
                            offset: this.convertOffset(this.state.y4a),
                          }
                        )}
                      />
                    </button>
                    <button
                      className="btn-trigger"
                      onClick={() => this.moveDown("4a")}
                    >
                      <img
                        width="25"
                        src={downImg}
                        alt={intl.formatMessage(
                          {
                            id: "Gene-edited macrophage cells (edit 7). Move alpha tubulin band down. Currently set to {offset} bp.",
                            defaultMessage:
                              "Gene-edited macrophage cells (edit 7). Move alpha tubulin band down. Currently set to {offset} bp.",
                            description: "",
                          },
                          {
                            offset: this.convertOffset(this.state.y4a),
                          }
                        )}
                      />
                    </button>
                  </div>
                  <div
                    id="4b"
                    className={
                      "draggable particle" +
                      (this.props.toggles.lane4 ? "" : " hidden")
                    }
                    draggable
                    style={{
                      transform:
                        "translate3d(0px, " +
                        this.state.y4b +
                        "px, 0px) rotateZ(0deg)",
                      zIndex: 10,
                      position: "absolute",
                      pointerEvents: "none",
                    }}
                  >
                    <button
                      className="btn-trigger"
                      onClick={() => this.moveUp("4b")}
                    >
                      <img
                        width="25"
                        src={upImg}
                        alt={intl.formatMessage(
                          {
                            id: "Gene-edited macrophage cells (edit 7). Move CCR5 band up. Currently set to {offset} bp.",
                            defaultMessage:
                              "Gene-edited macrophage cells (edit 7). Move CCR5 band up. Currently set to {offset} bp.",
                            description: "",
                          },
                          {
                            offset: this.convertOffset(this.state.y4b),
                          }
                        )}
                      />
                    </button>
                    <button
                      className="btn-trigger"
                      onClick={() => this.moveDown("4b")}
                    >
                      <img
                        width="25"
                        src={downImg}
                        alt={intl.formatMessage(
                          {
                            id: "Gene-edited macrophage cells (edit 7). Move CCR5 band down. Currently set to {offset} bp.",
                            defaultMessage:
                              "Gene-edited macrophage cells (edit 7). Move CCR5 band down. Currently set to {offset} bp.",
                            description: "",
                          },
                          {
                            offset: this.convertOffset(this.state.y4b),
                          }
                        )}
                      />
                    </button>
                  </div>
                </div>
              </div>

              <img
                alt="prediction"
                className="prediction-bg"
                style={{ pointerEvents: "none" }}
                src={gelPrediction}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    bands: state.predictions.bands,
    toggles: state.predictions.toggles,
  };
};

const GelPredictions512WithIntl = injectIntl(GelPredictions512);

export default connect(mapStateToProps, {
  setGelPrediction,
  setGelPredictionBandToggle,
})((props) => (
  <TranslationsProvider fetchTranslations={fetchTranslations}>
    <GelPredictions512WithIntl {...props} />
  </TranslationsProvider>
));
